<template>
  <div v-if="isPhone && seatSelected && outOfForm"
       class="scrollButton btn btn-sm btn-secondary rounded-circle shadow"
       @click="store.scrollTop()">
    <div class="p-2">
<!--      <svg v-if="whereAmI === 'pod'" xmlns="http://www.w3.org/2000/svg" height="20" width="15" viewBox="0 0 384 512">-->
<!--        &lt;!&ndash;!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.&ndash;&gt;-->
<!--        <path fill="#ffffff"-->
<!--              d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/>-->
<!--      </svg>-->

<!--      <svg v-if="whereAmI === 'nad'" xmlns="http://www.w3.org/2000/svg" height="20" width="15" viewBox="0 0 384 512">-->
<!--        &lt;!&ndash;!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.&ndash;&gt;-->
<!--        <path fill="#ffffff"-->
<!--              d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>-->
<!--      </svg>-->
      <span style="font-size: 10px;">
        <p class="m-0 text-14" style="line-height: 100%;">{{t('backToFormBtn.zpet')}}</p>
        <p class="m-0 text-14" style="line-height: 100%;">{{t('backToFormBtn.na')}}</p>
        <p class="m-0 text-14" style="line-height: 100%;">{{t('backToFormBtn.formular')}}</p>
<!--        <br> na<br> formulář-->
      </span>
    </div>
  </div>
</template>
<script>
import {store} from "@/components/store";
import {useI18n} from "vue-i18n";

export default {
  setup(){
    const {t} = useI18n({useScope: 'global'})
    return {t}
  },
  data() {
    return {
      isPhone: window.innerWidth <= 767,
      store,
      outOfForm: false,
      whereAmI: "pod"
    }
  },
  computed: {
    seatSelected() {
      return this.store.order.seatChoose
          || this.store.order.oborZivnosti;
    },
  },
  methods: {
    handleScroll() {
      const viewportTop = window.scrollY;
      const viewportBottom = window.scrollY + window.innerHeight;

      const appElement = document.getElementById('appJakeTrade');
      const appRect = appElement.getBoundingClientRect();
      const appTop = appRect.top + window.scrollY;
      const appBottom = appTop + appElement.offsetHeight;

      if (viewportBottom < appTop) {
        this.outOfForm = true;
        this.whereAmI = "nad";
      } else if (viewportTop > appBottom) {
        this.outOfForm = true;
        this.whereAmI = "pod"
      } else {
        this.outOfForm = false;
      }
    },
    handleResize() {
      this.isPhone = window.innerWidth <= 767;

    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize)
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>
<style scoped>
.scrollButton {
  position: fixed;
  left: 1rem;
  bottom: 1rem;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000000000000000;
}
</style>